import { useEffect, useState } from 'react';

import {
    setEncryptionSecret,
    useAuthentication,
    useGuestUser,
} from '@speeki/firebase-chat';

import { useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables';

export const useMyReportChat = (
    caseId?: string,
    chatRoomSecret?: string | null,
    firebaseToken?: string | null,
) => {
    const { isGuest, isLoggedIn } = useReactiveVar(authVar);
    const [isChatInit, setIsChatInit] = useState(false);
    const { firebaseAuthentication, signOut } = useAuthentication();
    const { setGuestUser } = useGuestUser();

    useEffect(() => {
        return () => {
            if (!isLoggedIn) void signOut();
        };
    }, [isLoggedIn]);

    useEffect(() => {
        void (async () => {
            if (isChatInit || !caseId || !chatRoomSecret) return;
            if (isLoggedIn && !isGuest) {
                setEncryptionSecret(caseId, chatRoomSecret);
                setIsChatInit(true);
            } else if (firebaseToken) {
                setGuestUser({
                    uuid: `GUEST-${caseId}`,
                    type: 'GUEST',
                });
                await firebaseAuthentication(firebaseToken);
                setEncryptionSecret(caseId, chatRoomSecret);
                setIsChatInit(true);
            }
        })();
    }, [isGuest, isLoggedIn, chatRoomSecret, firebaseToken, caseId]);

    return {
        chatId: caseId,
        isChatInit,
    };
};
